/* <kg-carousel>: Reihe von Kacheln, die sich seitlich schieben laesst. Am Desktop mit Pfeilen, mobil per Wischen. */

class KgCarousel extends HTMLElement {
  connectedCallback() {
    this.spur = this.querySelector('[data-carousel-track]');
    this.zurueck = this.querySelector('[data-carousel-prev]');
    this.vor = this.querySelector('[data-carousel-next]');
    if (!this.spur) return;

    this.zurueck?.addEventListener('click', () => this.schieben(-1));
    this.vor?.addEventListener('click', () => this.schieben(1));

    this.pruefen = () => this.zustand();
    this.spur.addEventListener('scroll', this.pruefen, { passive: true });
    window.addEventListener('resize', this.pruefen);

    if ('ResizeObserver' in window) {
      this.groesse = new ResizeObserver(this.pruefen);
      this.groesse.observe(this.spur);
    }

    this.zustand();
  }

  disconnectedCallback() {
    this.spur?.removeEventListener('scroll', this.pruefen);
    window.removeEventListener('resize', this.pruefen);
    this.groesse?.disconnect();
  }

  /* Eine Seite entspricht der sichtbaren Breite, abzueglich einer angeschnittenen Kachel */
  get schritt() {
    const karte = this.spur.querySelector('.card-product') || this.spur.firstElementChild;
    const breite = karte ? karte.getBoundingClientRect().width : this.spur.clientWidth;
    const abstand = parseFloat(getComputedStyle(this.spur).columnGap) || 0;
    /* Gerundet, denn die letzte Kachel einer Seite fuellt die Breite nicht ganz aus */
    const passen = Math.max(1, Math.round(this.spur.clientWidth / (breite + abstand)));
    return passen * (breite + abstand);
  }

  schieben(richtung) {
    this.spur.scrollBy({ left: this.schritt * richtung, behavior: 'smooth' });
  }

  zustand() {
    const rest = this.spur.scrollWidth - this.spur.clientWidth;
    /* Ohne Ueberlauf braucht es keine Pfeile */
    const noetig = rest > 4;
    this.toggleAttribute('data-scrollable', noetig);
    /* Auch ohne Pfeile braucht das Blatt die Lage, etwa fuer einen Verlauf am Rand */
    this.toggleAttribute('data-at-start', this.spur.scrollLeft <= 2);
    this.toggleAttribute('data-at-end', this.spur.scrollLeft >= rest - 2);
    if (this.zurueck) this.zurueck.disabled = !noetig || this.spur.scrollLeft <= 2;
    if (this.vor) this.vor.disabled = !noetig || this.spur.scrollLeft >= rest - 2;
  }
}

customElements.define('kg-carousel', KgCarousel);
